import { ABRIR_EJERCICIO,CERRAR_EJERCICIO, TERMINA_RECORRIDO, MUEVE_SLIDER,
	RESIZE,MUEVE_TRANSDUCTOR,ADD_RECORRIDOS,SET_MODO_TRANSDUCTOR, RESETEA_RECORRIDO,
	ACTUALIZA_CARGADO,LOGIN_USER, UPDATE_USER_DATA, NAVEGA, CARGA_ABORDAJE, SITUAR_IMAGEN, ABRIR_VIDEO, CERRAR_VIDEO } from "../constants/actions-types";

function abrirEjercicio(ejercicio) {
	return { type: ABRIR_EJERCICIO, ejercicio };
}

function cerrarEjercicio(){
	return {type:CERRAR_EJERCICIO};
}

function abrirVideo(video) {
	return { type: ABRIR_VIDEO,video };
}

function cerrarVideo(){
	return {type:CERRAR_VIDEO};
}

function resizeWindow(size){
	return {type:RESIZE,size};
}

function addRecorridos(recorridos){
	return {type:ADD_RECORRIDOS,recorridos};
}

function reseteaRecorrido(inicial){
	return {type:RESETEA_RECORRIDO,inicial};
}

function mueveTransductor(dir){
	return {type:MUEVE_TRANSDUCTOR, dir};
}

function mueveSlider(dir){
	return {type:MUEVE_SLIDER,dir};
}

function setModoTransductor(modo){
	return {type:SET_MODO_TRANSDUCTOR, modo};
}

function actualizaCargando(cargando){
	return {type: ACTUALIZA_CARGADO, cargando};
}

function loginUsuario(usuario){
	return {type: LOGIN_USER, usuario};
}

function updateDataUser(datos){
	return {type: UPDATE_USER_DATA, datos};
}

function navega(pagina){
	return {type: NAVEGA, pagina};
}

function cargaAbordaje(numAbordaje){
	return {type: CARGA_ABORDAJE, numAbordaje};
}

function situarImagen(datos){
	return{type:SITUAR_IMAGEN, datos};
}

function terminaRecorrido(){
	return{type:TERMINA_RECORRIDO};
}

export{ abrirEjercicio , cerrarEjercicio, resizeWindow, addRecorridos, mueveTransductor,setModoTransductor, reseteaRecorrido, mueveSlider,
	actualizaCargando, loginUsuario, updateDataUser, navega, cargaAbordaje, situarImagen, terminaRecorrido,abrirVideo, cerrarVideo};